import axios from 'axios';

const PurInvoiceData = async (saleInvoiceId, connectionString, companyId) => {
  // const path = 'http://192.168.1.248:3107';
  try {
    const url = `${connectionString}/api/get-purchase-invoice-data/${saleInvoiceId}`;
    const res = await axios.get(url);
    console.log("API Response: ", res.data); // Log full response for debugging
    const { master, details } = res.data;
    console.log("Master Data: ", master);


    let imageBase64 = '';
    try {
      console.log(`HARSH: ${connectionString}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
      const iconRes = await axios.get(`${connectionString}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
      if (iconRes?.data?.success && iconRes.data.imageBase64) {
        console.log('Company logo fetched successfully');
        imageBase64 = iconRes.data.imageBase64;
      } else {
        console.warn('No logo returned from API');
      }
    } catch (iconErr) {
      console.warn('Failed to fetch company icon:', iconErr?.response?.data || iconErr.message);
    }

    // Check which tax is applicable based on master
    const isIGSTApplicable = parseFloat(master.IGST || '0') > 0;

    const items = (details || []).map(d => ({
      hsnCode: d.HSNNo || '',
      description: `${d.itemCode || ''} - ${d.description || ''}`,
      qty: d.Qty || 0,
      rate: d.Rate || 0,
      Unit: d.Unit,
      discount: d.Disc || 0,
      cgst: isIGSTApplicable ? 0 : (d.taxCGST || 0),
      sgst: isIGSTApplicable ? 0 : (d.taxSGST || 0),
      igst: isIGSTApplicable ? (d.taxIGST || 0) : 0,
      amount: (d.Qty || 0) * (d.Rate || 0) - (((d.Qty || 0) * (d.Rate || 0)) * (d.Disc || 0) / 100),

    }));

    console.log("item: ", items);

    return {
      companyName: master.clientDetails?.clientname || master.FirmName || '',
      clientAddress: master.clientDetails?.address || master.clientAddress || '',
      address: master.clientDetails?.address || master.shipToAddress || master.Address || '',
      phone: master.clientDetails?.mobileNo || master.shipToMobileNo || master.MobileNo || '',
      gstNo: master.clientDetails?.gstno || master.gstNumber || master.GSTNo || '',
      invoiceNo: master.BillNumber || master.BillNumber || '',
      date: master.BillDate
        ? new Date(master.BillDate).toLocaleDateString('en-GB')
        : '',
      transport: master.transporterName || 'SELF',
      challanNo: master.lrNumber || '',
      poNo: master.RefNo || '',
      shipToState: master.consigneeState || '',
      shipToStateCode: master.consigneeStateCode || '',
      LrNo: master.LRNo || '',
      VehicleNo: master.VehicleNo || '',
      LrDate: master.LRDate ? new Date(master.LRDate).toLocaleDateString('en-GB') : '',
      shipToGstNumber: master.consigneeDetails?.shipToGSTNo || master.shipToGstNumber || master.GSTNO || '',
      shipToConsigneename: master.consigneeDetails?.shipToConsigneename || master.ConName || '',
      items,
      toEmail: master.clientDetails?.emailId || master.shipToEmailId || master.EmailId || '',
      totalAmount: master.grandTotal || 0,
      mobileNo: master.clientDetails?.mobileNo || master.mobileNo || master.MobileNo || '',
      basicAmount: Number(master.BasicAmt) || 0,
      CGSTAmt: Number(master.CGSTAmt),
      SGSTAmt: Number(master.SGSTAmt),
      IGSTAmt: Number(master.IGSTAmt),
      RoundOff: Number(master.RoundOff),
      BillAmt: Number(master.BillAmt),
      clientState: master.clientState || '',
      clientStateCode: master.clientStateCode || '',
      imageBase64,
    };
  } catch (err) {
    console.error(`Error loading invoiceData for id=${saleInvoiceId}`, err);
    throw err;
  }
};

export default PurInvoiceData;